import { render, staticRenderFns } from "./ArchiveItem.vue?vue&type=template&id=95455acc&scoped=true&"
import script from "./ArchiveItem.vue?vue&type=script&lang=js&"
export * from "./ArchiveItem.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveItem.vue?vue&type=style&index=0&id=95455acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95455acc",
  null
  
)

export default component.exports